import { pipe } from 'ramda';
import { useCallback, useMemo } from 'react';
import { DueConfiguration } from 'api/timesheets/configuration/configuration';
import { DayOfWeek } from 'core/day-of-week';
import { filter, ifPresent, map } from 'core/maybe';
import { maybeValueOf } from 'core/state';
import { SetState, State, UseStateResult } from '../state';

export const useDay = (
  due: State<DueConfiguration>,
  setDue: SetState<DueConfiguration>,
): UseStateResult<DayOfWeek> => {
  const day = useMemo(
    () =>
      pipe(
        () => due,
        State.map((x) => x.day),
      )(),
    [due],
  );
  const setDay = useCallback(
    (next: DayOfWeek) => {
      pipe(
        () => due,
        maybeValueOf,
        filter((x) => x.day !== next),
        map((x) => ({ ...x, day: next })),
        ifPresent(setDue),
      )();
    },
    [due, setDue],
  );

  return [day, setDay];
};
